
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 10038","d":"M28.995 6a20 20 0 00-20 20 20 20 0 0020 20 20 20 0 0020-20 20 20 0 00-20-20z","fill":"#898c8d"}}),_c('g',{attrs:{"data-name":"Group 1439","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 10039","d":"M22.652 24.096h2.962v-.6a3.523 3.523 0 013.523-3.523 3.522 3.522 0 013.522 3.523v.6h2.962v-7.244H22.652z"}}),_c('path',{attrs:{"data-name":"Rectangle 1758","d":"M22.702 24.336h2.962v4.895h-2.962z"}}),_c('path',{attrs:{"data-name":"Rectangle 1759","d":"M22.702 29.471h2.962v4.895h-2.962z"}}),_c('path',{attrs:{"data-name":"Rectangle 1760","d":"M32.608 24.336h2.963v4.895h-2.963z"}}),_c('path',{attrs:{"data-name":"Rectangle 1761","d":"M32.608 29.471h2.963v4.895h-2.963z"}}),_c('path',{attrs:{"data-name":"Path 10040","d":"M22.651 35.278h12.97v-.672h-4.142v-5.382h-4.685v5.382h-4.142z"}}),_c('path',{attrs:{"data-name":"Rectangle 1762","d":"M36.16 21.734h9.08v2.362h-9.08z"}}),_c('path',{attrs:{"data-name":"Rectangle 1763","d":"M13 24.336h9.08v4.895H13z"}}),_c('path',{attrs:{"data-name":"Rectangle 1764","d":"M36.16 34.606h9.08v.672h-9.08z"}}),_c('path',{attrs:{"data-name":"Rectangle 1765","d":"M13 34.606h9.08v.672H13z"}}),_c('path',{attrs:{"data-name":"Rectangle 1766","d":"M13 21.734h9.08v2.362H13z"}}),_c('path',{attrs:{"data-name":"Rectangle 1767","d":"M13 29.471h9.08v4.895H13z"}}),_c('path',{attrs:{"data-name":"Rectangle 1768","d":"M36.16 29.471h9.08v4.895h-9.08z"}}),_c('path',{attrs:{"data-name":"Rectangle 1769","d":"M36.16 24.336h9.08v4.895h-9.08z"}})])])
          )
        }
      }
    